import ListVisits from "./listVisits";
const ListSiteVisits = () => <ListVisits type="site" />;
export default ListSiteVisits;